import React from 'react';
import { ClipLoader } from 'react-spinners';

const Loader = () => <ClipLoader speedMultiplier={0.8} size={70} color="var(--primary-color)" />;

export default Loader;
